import { FaLock, FaTimes } from "react-icons/fa";
import "./AuthDialog.css";

const AuthDialog = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="auth-dialog-overlay">
      <div className="auth-dialog">
        <button className="auth-dialog-close" onClick={onClose}>
          <FaTimes />
        </button>
        <div className="auth-dialog-content">
          <div className="auth-dialog-icon">
            <FaLock />
          </div>
          <h2 className="auth-dialog-title">Authentication Required</h2>
          <p className="auth-dialog-message">
            Please sign in or register to continue and access all features of
            the application.
          </p>
          <button className="auth-dialog-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthDialog;
